import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home/Home";
import BlogListPage from "./pages/BlogListPage";
import BlogDetails from "./components/BlogDetails";
import { ThemeProvider } from "./contexts/ThemeContext";

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 day-theme:from-blue-50 day-theme:via-purple-100 day-theme:to-pink-50 profile-theme:from-slate-900 profile-theme:via-slate-800 profile-theme:to-teal-600 relative overflow-hidden transition-all duration-500">
          {/* Main Content */}
          <div className="relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/blog" element={<BlogListPage />} />
              <Route path="/blog/:slug" element={<BlogDetails />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </div>

          {/* Ambient Light Effects */}
          <div className="fixed inset-0 pointer-events-none">
            <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse day-theme:bg-sky-400/20 profile-theme:bg-teal-500/15"></div>
            <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-pink-500/10 rounded-full blur-3xl animate-pulse delay-1000 day-theme:bg-blue-400/15 profile-theme:bg-cyan-500/12"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-cyan-500/5 rounded-full blur-2xl animate-pulse delay-500 day-theme:bg-indigo-400/12 profile-theme:bg-turquoise-500/10"></div>
          </div>

          {/* Profile Theme Ambient Light Orbs */}
          <div className="ambient-orb"></div>
          <div className="ambient-orb"></div>
          <div className="ambient-orb"></div>

          {/* Day Theme Fluorescent Blue Ambient Light Orbs */}
          <div className="day-ambient-orb"></div>
          <div className="day-ambient-orb"></div>
          <div className="day-ambient-orb"></div>
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default App;
